import { DependencyList, useEffect, useRef } from 'react';

export default function useDebounce(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callback: (...args: any) => void,
  delay: number,
  dependencies: DependencyList,
) {
  const callbackRef = useRef(callback);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(null);

  useEffect(() => {
    // Hack for not having to have callback in dependecy list so it doesn't reset on re-render
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => callbackRef.current(), delay);
    // Intentionally doesn't return a clearing function so callback is called even after component is no longer rendered
  }, [delay, dependencies]);

  // Clear timeout after the first render
  useEffect(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  }, []);
}
